import { Issue } from '@news-mono/web-common'
import React from 'react'
import { calcRem } from '../../__styling'
import {
    StyledEPaperBanner,
    StyledEPaperBannerWrapper,
    StyledEPaperButton,
    StyledEPaperChevon,
    StyledEPaperCoverLeft,
    StyledEPaperCoverRight,
    StyledEPaperDateTime,
    StyledEPaperHeadingEpaper,
    StyledEPaperHeadingToday,
    StyledEPaperHeadingWrapper,
    StyledEPaperLogo,
    StyledEPaperSubheading,
} from './ePaperPage.styled'

export interface ePaperPageProps {
    latestEdition: Issue
    allEditions: Issue[]
    onEvent: (event: any) => void
}

export const EPaperPage: React.FC<ePaperPageProps> = (props) => {
    return (
        <React.Fragment>
            <StyledEPaperHeadingWrapper>
                <StyledEPaperHeadingToday>Today's </StyledEPaperHeadingToday>
                <div style={{ paddingTop: calcRem(8) }}>
                    <StyledEPaperLogo />
                </div>
                <StyledEPaperHeadingEpaper>ePaper</StyledEPaperHeadingEpaper>
            </StyledEPaperHeadingWrapper>

            <StyledEPaperBanner>
                <StyledEPaperBannerWrapper>
                    <StyledEPaperDateTime>
                        {props.latestEdition?.date?.toLocaleDateString(
                            'en-AU',
                            { weekday: 'long', day: 'numeric', month: 'short' },
                        )}
                    </StyledEPaperDateTime>
                    <StyledEPaperSubheading>
                        As it was printed
                    </StyledEPaperSubheading>
                    <StyledEPaperButton
                        onClick={() =>
                            window.open(props.latestEdition?.url, '_blank')
                        }
                    >
                        Read now <StyledEPaperChevon />
                    </StyledEPaperButton>
                </StyledEPaperBannerWrapper>
                <StyledEPaperCoverLeft
                    src={props.latestEdition?.coverUrl}
                    draggable={false}
                />
                <StyledEPaperCoverRight
                    draggable={false}
                    src={props.latestEdition?.coverUrl}
                />
            </StyledEPaperBanner>
        </React.Fragment>
    )
}

EPaperPage.displayName = 'ePaperPage'

export default EPaperPage
